import { type FC, memo } from 'react';
import Input, { type InputProps } from '.';
import searchIcon from '@assets/images/icons/search.svg';

const SearchInput: FC<InputProps> = ({ suffix, ...rest }) => {
  return <Input {...rest} suffix={suffix || <img src={searchIcon} data-icon />} />;
};

export default memo(SearchInput);
